import React from "react";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import GPAP_Button from "../../../../../gpap-lib/Button_Collection";

const SearchFrame =(props)=>{    
    return (
        <FormControl>
            <Typography variant={"h6"}> Experiments selection  </Typography>
            <FormLabel id="row-radio-buttons-group-label">Field Filtering</FormLabel>
            <Stack direction="row" spacing={2}>
                <RadioGroup row aria-labelledby="row-radio-buttons-group-label"  name="row-radio-buttons-group" 
                            value={props.fieldSelected} onChange={props.handleRadioChange}>
                    {props.header.map((item) => (
                      <FormControlLabel value={item.dataKey} control={<Radio />} label={item.label} />
                    ))}
                </RadioGroup>
                <TextField id="search" label={"Search " + props.fieldSelected} 
                           variant="outlined" value={props.search} 
                           onChange={props.handleSearchChange}/>
                <GPAP_Button onClick={props.searchButtonHandler}> 
                    <i class="fa fa-search" aria-hidden="true"></i> SEARCH 
                </GPAP_Button>
            </Stack>
        </FormControl>
    );
}

export default SearchFrame;
